<template>
    <modal
        name="product-modals-modal"
        adaptive
        scrollable
        height="auto"
        @before-open="handleModalBeforeOpen"
    >
        <div class="py-10 px-10 bg-tassels">

            <div class="mb-5 flex justify-between items-center">
                <CloseIcon
                    class="close-icon"
                    @click="closeModal"
                />
            </div>

            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="html" />

        </div>
    </modal>
</template>

<script>
import CloseIcon from '~/static/fonts/LineIcons/close.svg';

export default {

    components: {
        CloseIcon,
    },

    data() {
        return {
            title: '',
            html: '',
        };
    },

    methods: {
        handleModalBeforeOpen({ params }) {
            this.title = params.title;
            this.html = params.html;
        },
        closeModal() {
            this.$modal.hide('product-modals-modal');
        },
    },

};
</script>

<style lang="scss" scoped>
.close-icon {
    @apply h-5 cursor-pointer transition-fast;
    &:hover {
        @apply opacity-50;
    }
}
.bg-tassels {
    background-image: url('https://admin.bubblegumballoons.com/uploads/header_image.jpg');
    background-position: top center;
    background-repeat: no-repeat;
}
</style>
